import React from 'react';
import Axios from 'axios';

const ADMIN_LVL_SEASONS = 3;
const ADMIN_LVL_SCORESHEETS = 10;

class Admin_HomeTab extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			season: this.props.season
		};
	
		this.handleMsgChange = this.handleMsgChange.bind(this);
		this.handleMsg2Change = this.handleMsg2Change.bind(this);
		this.handleButtonText1Chg = this.handleButtonText1Chg.bind(this);
		this.handleButtonLink1Chg = this.handleButtonLink1Chg.bind(this);
		this.handleButtonText2Chg = this.handleButtonText2Chg.bind(this);
		this.handleButtonLink2Chg = this.handleButtonLink2Chg.bind(this);
		this.handleClickSave = this.handleClickSave.bind(this);
	}

	componentDidMount() {
		//console.log('ADMIN_HomeTab: componentDidMount');
		//console.log(this.props);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		//console.log('Admin_HomeTab: UNSAFE_componentWillReceiveProps');
		this.setState({
			season: nextProps.season
		})
	}

	render() {
		//console.log('Admin_HomeTab: RENDER');
		//console.log(this.props.adminAccess.adminValidatedAccessLevel);

		// ADMIN LEVEL REQUESTED:  03-SEASON
		if (this.props.adminAccess.adminValidatedAccessLevel <= ADMIN_LVL_SEASONS) {
			return (
				<div>
				<div className="row">
				<div className="col-md-12">
					<h5>Saison - Paramètres généraux</h5>
				</div>
				</div>
				<br/>

				<div className="row">
				<div className="col-md-9">
					Message de la Ligue - affiché en entête des classements <br/>
					<i>(l'utilisation de liens URL est permise et supportée)</i>
					<textarea className="form-control" rows="8" id="seasonMsg" 
						value={this.state.season.seasonMessage || ''} onChange={this.handleMsgChange}/>
					<br/>
				</div>
				</div>

				<div className="row">
				<div className="col-md-9">
					Texte du bouton #1 dans le message de la Ligue (laisser vide si aucun bouton à afficher, 40 caractères max)
					<input className="form-control" maxLength="40" id="txtbtn1" 
						value={this.state.season.seasonMessageButtonText1 || ''} onChange={this.handleButtonText1Chg}/>
					<br/>
				</div>
				</div>

				<div className="row">
				<div className="col-md-9">
					Lien du bouton #1 dans le message de la Ligue (http://...)
					<input className="form-control" id="linkbtn1" 
						value={this.state.season.seasonMessageButtonLink1 || ''} onChange={this.handleButtonLink1Chg}/>
					<br/>
				</div>
				</div>

				<div className="row">
				<div className="col-md-9">
					Texte du bouton #2 dans le message de la Ligue (laisser vide si aucun bouton à afficher, 40 caractères max)
					<input className="form-control" maxLength="40" id="textbtn2" 
						value={this.state.season.seasonMessageButtonText2 || ''} onChange={this.handleButtonText2Chg}/>
					<br/>
				</div>
				</div>

				<div className="row">
				<div className="col-md-9">
					Lien du bouton #2 dans le message de la Ligue (http://...)
					<input className="form-control" id="linkbtn2" 
						value={this.state.season.seasonMessageButtonLink2 || ''} onChange={this.handleButtonLink2Chg}/>
					<br/>
				</div>
				</div>

				<div className="row">
				<div className="col-md-9">
					Message de Statelo - affiché à la suite du message de saison <br/>
					<i>(ne pas modifier svp)</i>
					<textarea className="form-control" rows="6" id="statelomsg" 
						value={this.state.season.seasonMessage2 || ''} onChange={this.handleMsg2Change}/>
					<br/>
				</div>
				</div>

				<div className="row">
				<div className="col-md-12">
					<input type="button" className="btn btn-primary" value="Sauvegarder" onClick={this.handleClickSave} />
				</div>
				</div>

				</div>
			);

		} else {
			return (
				<div className="col-md-9">   {/*padding-left already set in parent*/} 
					<p>Vous n'avez pas accès à cette section pour la saison sélectionnée</p>
				</div>
			);
		}
	}

	handleMsgChange(e) {
		var textvalue = e.target.value;
		var season = this.state.season;

		season.seasonMessage = textvalue;
		this.setState({
			season: season
		})
	}

	handleButtonText1Chg(e) {
		var textvalue = e.target.value;
		var season = this.state.season;

		season.seasonMessageButtonText1 = textvalue;
		this.setState({
			season: season
		})
	}

	handleButtonLink1Chg(e) {
		var textvalue = e.target.value;
		var season = this.state.season;

		season.seasonMessageButtonLink1 = textvalue;
		this.setState({
			season: season
		})
	}

	handleButtonText2Chg(e) {
		var textvalue = e.target.value;
		var season = this.state.season;

		season.seasonMessageButtonText2 = textvalue;
		this.setState({
			season: season
		})
	}

	handleButtonLink2Chg(e) {
		var textvalue = e.target.value;
		var season = this.state.season;

		season.seasonMessageButtonLink2 = textvalue;
		this.setState({
			season: season
		})
	}

	handleMsg2Change(e) {
		var textvalue = e.target.value;
		var season = this.state.season;

		season.seasonMessage2 = textvalue;
		this.setState({
			season: season
		})
	}

	handleClickSave() {
		var season = this.state.season;

		// post subPlayers to season
		Axios.post('/api/seasons/' + season._id, {
			season: season
		})
		.then(function(response) {
			//console.log('save success');
		})
		.catch(function(error) {
			console.log(error);
		});
	}

}

export default Admin_HomeTab;
